import React from "react";
import { Link } from "react-router-dom";
import "./AppsSection.css";
import dawgIcon from "../images/dawgIcon.png";
import mioIcon from "../images/mioIcon.png";
import trueformIcon from "../images/trueformIcon.png";
import swingsightIcon from "../images/swingsightIcon.png";

const AppsSection = () => {
  const dawgFeatures = [
    "Daily challenges to build discipline",
    "Track your progress and streaks",
    "Push beyond your comfort zone",
    "Build winning habits that stick",
  ];

  const mioFeatures = [
    "A character that evolves with your progress",
    "Habits, streaks, and clear milestones",
    "Track workouts and meals without the noise",
    "AI coaching, focus tools, and community",
  ];

  const trueformFeatures = [
    "Personalized mobility and recovery programs",
    "Guided sessions built around how you feel",
    "AI coaching that adapts to your progress",
    "Feel your best with plans that fit your body",
  ];

  const swingsightFeatures = [
    "AI analysis of your golf swing",
    "Clear coaching on what to work on",
    "A drill library to improve",
    "Practice plans built around your game",
  ];

  return (
    <section className="apps" id="apps">
      <div className="apps-container">
        <div className="apps-header">
          <span className="apps-label">WHAT WE'VE BUILT</span>
          <h2 className="apps-title">
            OUR <span className="gold">APPS</span>
          </h2>
        </div>

        <div className="app-showcase">
          <div className="app-card featured">
            <div className="app-icon-wrapper">
              <img
                src={dawgIcon}
                alt="DAWG App Icon"
                className="app-icon-img"
              />
              <div className="app-header-content">
                <div className="app-title-row">
                  <h3 className="app-name">DAWG</h3>
                  <span className="app-badge">FEATURED</span>
                </div>
                <p className="app-tagline">
                  The ultimate self-improvement app for men who refuse to be
                  average.
                </p>
              </div>
            </div>

            <p className="app-description">
              Build discipline, confidence, and winning habits. Every day, DAWG
              challenges you with actionable tasks that push you to step
              up—physically, mentally, and socially.
            </p>

            <ul className="app-features-list">
              {dawgFeatures.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>

            <div className="app-cta">
              <a
                href="https://apps.apple.com/us/app/dawg-discipline-motivation/id6742336314"
                target="_blank"
                rel="noopener noreferrer"
                className="store-button"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="24"
                  height="24"
                >
                  <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
                </svg>
                <div className="store-text">
                  <span className="store-label">Download on the</span>
                  <span className="store-name">App Store</span>
                </div>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.DawgLabs.DAWG&hl=en_US"
                target="_blank"
                rel="noopener noreferrer"
                className="store-button"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="24"
                  height="24"
                >
                  <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z" />
                </svg>
                <div className="store-text">
                  <span className="store-label">Get it on</span>
                  <span className="store-name">Google Play</span>
                </div>
              </a>
            </div>

            <div className="app-legal-links">
              <Link to="/dawg/support" className="app-legal-link">
                Support
              </Link>
              <span className="app-legal-divider">·</span>
              <Link to="/dawg/privacy" className="app-legal-link">
                Privacy Policy
              </Link>
              <span className="app-legal-divider">·</span>
              <Link to="/dawg/terms" className="app-legal-link">
                Terms of Use
              </Link>
            </div>
          </div>

          <div className="app-card" id="mio">
            <div className="app-icon-wrapper">
              <img
                src={mioIcon}
                alt="Mio App Icon"
                className="app-icon-img"
              />
              <div className="app-header-content">
                <div className="app-title-row">
                  <h3 className="app-name">Mio</h3>
                </div>
                <p className="app-tagline">
                  Evolve into the best version of you.
                </p>
              </div>
            </div>

            <p className="app-description">
              Mio helps you stay consistent with habits, fitness, and nutrition —
              and gives that progress a face. As you show up, your character
              levels up too.
            </p>

            <ul className="app-features-list">
              {mioFeatures.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>

            <div className="app-cta">
              <a
                href="https://apps.apple.com/app/id6783861950"
                target="_blank"
                rel="noopener noreferrer"
                className="store-button"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="24"
                  height="24"
                >
                  <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
                </svg>
                <div className="store-text">
                  <span className="store-label">Download on the</span>
                  <span className="store-name">App Store</span>
                </div>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.DWGLabs.Mio&hl=en_AU"
                target="_blank"
                rel="noopener noreferrer"
                className="store-button"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="24"
                  height="24"
                >
                  <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z" />
                </svg>
                <div className="store-text">
                  <span className="store-label">Get it on</span>
                  <span className="store-name">Google Play</span>
                </div>
              </a>
            </div>

            <div className="app-legal-links">
              <Link to="/mio/support" className="app-legal-link">
                Support
              </Link>
              <span className="app-legal-divider">·</span>
              <Link to="/mio/privacy" className="app-legal-link">
                Privacy Policy
              </Link>
              <span className="app-legal-divider">·</span>
              <Link to="/mio/terms" className="app-legal-link">
                Terms of Use
              </Link>
            </div>
          </div>

          <div className="app-card" id="trueform">
            <div className="app-icon-wrapper">
              <img
                src={trueformIcon}
                alt="Trueform App Icon"
                className="app-icon-img"
              />
              <div className="app-header-content">
                <div className="app-title-row">
                  <h3 className="app-name">Trueform</h3>
                </div>
                <p className="app-tagline">
                  Personalized mobility and recovery so you can feel your best.
                </p>
              </div>
            </div>

            <p className="app-description">
              Trueform generates personalized programs for mobility, recovery,
              and movement — built around your body, goals, and how you feel
              today.
            </p>

            <ul className="app-features-list">
              {trueformFeatures.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>

            <div className="app-cta">
              <a
                href="https://apps.apple.com/us/app/trueform-stretch-mobility/id6783914054"
                target="_blank"
                rel="noopener noreferrer"
                className="store-button"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="24"
                  height="24"
                >
                  <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
                </svg>
                <div className="store-text">
                  <span className="store-label">Download on the</span>
                  <span className="store-name">App Store</span>
                </div>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.dwglabs.ptapp"
                target="_blank"
                rel="noopener noreferrer"
                className="store-button"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  width="24"
                  height="24"
                >
                  <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z" />
                </svg>
                <div className="store-text">
                  <span className="store-label">Get it on</span>
                  <span className="store-name">Google Play</span>
                </div>
              </a>
            </div>

            <div className="app-legal-links">
              <Link to="/trueform/support" className="app-legal-link">
                Support
              </Link>
              <span className="app-legal-divider">·</span>
              <Link to="/trueform/privacy" className="app-legal-link">
                Privacy Policy
              </Link>
              <span className="app-legal-divider">·</span>
              <Link to="/trueform/terms" className="app-legal-link">
                Terms of Use
              </Link>
            </div>
          </div>

          <div className="app-card" id="swingsight">
            <div className="app-icon-wrapper">
              <img
                src={swingsightIcon}
                alt="SwingSight App Icon"
                className="app-icon-img"
              />
              <div className="app-header-content">
                <div className="app-title-row">
                  <h3 className="app-name">SwingSight</h3>
                </div>
                <p className="app-tagline">
                  An AI coach for your golf swing.
                </p>
              </div>
            </div>

            <p className="app-description">
              SwingSight analyzes your swing and tells you what to work on,
              then gives you drills from the library so you can improve.
            </p>

            <ul className="app-features-list">
              {swingsightFeatures.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>

            <div className="app-legal-links">
              <Link to="/swingsight/support" className="app-legal-link">
                Support
              </Link>
              <span className="app-legal-divider">·</span>
              <Link to="/swingsight/privacy" className="app-legal-link">
                Privacy Policy
              </Link>
              <span className="app-legal-divider">·</span>
              <Link to="/swingsight/terms" className="app-legal-link">
                Terms of Use
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppsSection;
